import { AppShell, Box } from '@mantine/core';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { TruncationTooltip } from '@/components/common/TruncationTooltip';
import { AppHeader } from '@/components/layout/AppHeader';
import { AppNavbar } from '@/components/layout/AppNavbar';
import { BreadcrumbProvider } from '@/components/layout/BreadcrumbContext';
import { MobileBackProvider } from '@/components/layout/MobileBackContext';
import { PageHeader } from '@/components/layout/PageHeader';

// Isti obrazac pamćenja kao odabrani jezik (i18next → localStorage) — korisnikov
// odabir sklopljenog/rasklopljenog izbornika preživi reload i sljedeću sesiju.
const NAV_COLLAPSED_KEY = 'externo_nav_collapsed';

export const AppLayout = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [desktopCollapsed, setDesktopCollapsed] = useState(
    () => localStorage.getItem(NAV_COLLAPSED_KEY) === 'true'
  );

  const toggleDesktopCollapsed = () => {
    setDesktopCollapsed((collapsed) => {
      const next = !collapsed;
      localStorage.setItem(NAV_COLLAPSED_KEY, String(next));
      return next;
    });
  };

  return (
    <BreadcrumbProvider>
      <MobileBackProvider>
        <AppShell
          header={{ height: { base: 56, sm: 0 } }}
          navbar={{
            width: { base: 248, sm: desktopCollapsed ? 80 : 248 },
            breakpoint: 'sm',
            collapsed: { mobile: !mobileNavOpen }
          }}
          padding={0}
        >
          <AppShell.Header hiddenFrom="sm" style={{ border: 'none' }}>
            <AppHeader
              navbarOpen={mobileNavOpen}
              onNavbarToggle={() => setMobileNavOpen((open) => !open)}
            />
          </AppShell.Header>

          <AppShell.Navbar className="app-navbar">
            <AppNavbar
              onNavigate={() => setMobileNavOpen(false)}
              collapsed={desktopCollapsed}
              onToggleCollapse={toggleDesktopCollapsed}
            />
          </AppShell.Navbar>

          {mobileNavOpen && (
            <Box
              hiddenFrom="sm"
              className="app-navbar-overlay"
              onClick={() => setMobileNavOpen(false)}
            />
          )}

          <AppShell.Main className="app-main" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
            <PageHeader />
            <Box p={{ base: 16, sm: 32 }}>
              <Outlet />
            </Box>
          </AppShell.Main>
        </AppShell>
        <TruncationTooltip />
      </MobileBackProvider>
    </BreadcrumbProvider>
  );
};
